import React from "react";
import PropTypes from "prop-types";
import BlogPostWrapper from "./blogpost.style";

const BlogPost = ({ className, title, content, link }) => {
  // Add all classs to an array
  const addAllClasses = ["blog_post"];

  // className prop checking
  if (className) {
    addAllClasses.push(className);
  }

  const html = {
    __html: content.replace(
      /https?:\/\/(ordoo|ordable).co.uk\/blog\/wp-content\/uploads/g,
      "https://ordoo-blog.s3.eu-west-2.amazonaws.com"
    )
  };

  return (
    <BlogPostWrapper>
      <div className={addAllClasses.join(" ")}>
        <div className="content">
          <h1 className="title">{title}</h1>
          <div className="content" dangerouslySetInnerHTML={html}></div>
          {link && <div className="learn_more">{link}</div>}
        </div>
      </div>
    </BlogPostWrapper>
  );
};

BlogPost.propTypes = {
  className: PropTypes.string,
  thumbUrl: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.string,
  link: PropTypes.element
};

export default BlogPost;
